// extracted by mini-css-extract-plugin
export default {"card":"Card_card__HELKK","card__interactive":"Card_card__interactive__hxAJj","flexRow":"Card_flexRow__YeFBX"};